<template>
  <div class="popup-ages-overlay">
    <div class="popup-container">
      <h2 class="popup-title">
        {{$t('shared.ages_title')}}
      </h2>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="submitForm(invalid)">
          <div class="form-container py-8">
            <div
              class="passenger-input passenger-input_childs flex items-center"
              v-for="(item, index) in items.children"
              :key="item.id"
            >
              <div class="popup-info flex flex-col">
                <span class="capitalize">{{$tc('shared.child',1)}} {{ index + 1 }}</span>
                <span class="pt-1">2 - 18 {{$t('shared.years')}}</span>
              </div>
              <ValidationProvider rules="integer|between:2,18" v-slot="{ errors }">
                <input
                  v-bind:class="{
                    'input-style-error':
                      (item.age > 18 || item.age < 2) && item.age != '',
                  }"
                  type="number"
                  :placeholder="$t('shared.years')"
                  v-model="item.age"
                  name="Age"
                  class="ml-4 mr-1"
                  required
                />

                <span>{{$t('shared.years')}}</span>
                <span class="errorInput">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div
              class="passenger-input passenger-input_babies flex items-center"
              v-for="(item, index) in items.babies"
              :key="item.id"
            >
              <div class="popup-info flex flex-col">
                <span class="capitalize">{{$tc('shared.baby', 1)}} {{ index + 1 }}</span>
                <span class="pt-1">1 - 2 {{$t('shared.years')}}</span>
              </div>
              <ValidationProvider rules="integer|between:1,2" v-slot="{ errors }">
                <input
                  v-bind:class="{
                    'input-style-error':
                      (item.age > 2 || item.age < 1) && item.age != '',
                  }"
                  type="number"
                  :placeholder="$t('shared.years')"
                  name="Age"
                  v-model="item.age"
                  class="ml-4 mr-1"
                  required
                />

                <span>{{$t('shared.years')}}</span>
                <span class="errorInput">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <button
            class="done self-end flex items-center justify-right ml-auto"
            type="submit"
          >
            <span class="mr-1 font-bold">{{$t('shared.ready')}}</span>
            <v-icon>mdi-chevron-right</v-icon>
          </button>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { between, integer } from "vee-validate/dist/rules";

extend("between", between);
extend("integer", integer);

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    items: {
      type: Object,
      default: {
        childs: [],
        babys: [],
      },
    },
  },
  methods: {
    submitForm(invalid) {
      if (invalid) return;

      this.$emit("submitFormEvent", this.items);
    },
  },
};
</script>

<style lang="scss">
@import "../../../../sass/_variables.scss";
.popup-ages-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: 0.3);
  width: 100%;
  height: 100%;

  .popup-container {
    background-color: white;
    max-width: 529px;
    padding: 36px;
    display: flex;
    overflow: auto;
    flex-direction: column;
    border-radius: 15px;

    @media (max-width: 1024px) {
      height: 70vh;
      max-width: 90%;
    }

    .popup-title {
      font-size: 22px;
      line-height: 30px;
      font-weight: bold;
    }

    .done {
      cursor: pointer;

      @media (max-width: 1024px) {
        display: flex;
        align-items: flex-end;
        margin: 0 auto;
      }

      span,
      i {
        color: $turquoiseBlue;
      }
    }
  }
  .form-container {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 25px;

    @media (min-width: 1024px) {
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 35px;
    }

    .passenger-input {
      position: relative;
      .popup-info {
        flex: 0 auto !important;
        & span:first-child {
          font-size: 16px;
          font-weight: bold;
        }

        & span:last-child {
          font-size: 11px;
        }
      }

      input[type="number"] {
        width: 70px;
        height: 48px;
        border: 1px solid #b7b7b7;
        border-radius: 5px;
        padding-left: 10px;
        padding-right: 10px;

        &:focus {
          border-color: #000000;
        }

        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }

      .errorInput {
        position: absolute;
        font-size: 11px;
        color: red;
        bottom: -21px;
        right: 73px;
      }

      .input-style-error {
        border-color: red !important;
      }
    }
  }
}
</style>
